module.exports = __webpack_public_path__ + "static/media/arson.cfdec637.svg";